import { ColumnDef } from '@tanstack/react-table'
import { Contact } from '../../../api/contacts/types'
import { PageListParams } from '../../../api/globalTypes'
import { MODAL_TYPES } from '../../../common/constants'
import { FilteredContact } from '../utils'

interface GetModalPayloadsProps {
    modalType: string
    selectedTableRows: FilteredContact[]
    params: PageListParams
    columns: ColumnDef<Contact>[]
}

export const getModalPayloads = (props: GetModalPayloadsProps) => {
    const { modalType, selectedTableRows, params, columns } = props
    const { DELETE_MODAL, EXPORT_DATA_MODAL, CHANGE_AGENT_MODAL } = MODAL_TYPES

    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    callbackId: 'delete-contacts',
                    appModule: 'contact',
                },
            }
        case EXPORT_DATA_MODAL:
            return {
                modalType: EXPORT_DATA_MODAL,
                modalProps: {
                    params,
                    tableColumns: columns,
                    selectedRowsIds: selectedTableRows.map((row) => row.id),
                    appModule: 'contact',
                },
            }
        case CHANGE_AGENT_MODAL:
            return {
                modalType: CHANGE_AGENT_MODAL,
                modalProps: {
                    modalData: selectedTableRows.map((row) => ({
                        id: row.id,
                        internalAppId: row.internalAppId,
                        city: row.city,
                        agentFirstName: row.agentFirstName,
                        agentLastName: row.agentLastName,
                        contactPerson: row.contactPerson,
                    })),
                },
            }
        default:
            return null
    }
}
